<template>
  <v-dialog
    v-model="dialog"
    max-width="900px"
    @click:outside="$emit('changeValue', false)"
    @keydown.esc="$emit('changeValue', false)"
  >
    <v-card>
      <v-card-title class="headline">
        <slot name="title" />
      </v-card-title>
      <v-card-text>
        <span v-if="loading && messages.length === 0" style="font-size: 14px">
          Carregando mensagens... por favor, aguarde.
        </span>
        <span v-else-if="!loading && messages.length === 0" style="font-size: 14px">
          Nenhum log disponível ainda.
        </span>
        <table v-else id="dialog-acompanhamento-logs--table">
          <thead>
            <tr>
              <th style="text-align: initial">Últimas linhas do log</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(message, i) in filteredMessages" :key="i">
              <td>{{ message }}</td>
            </tr>
          </tbody>
        </table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'DialogAcompanhamentoLogs',
    props: {
      showDialog: {
        type: Boolean,
        required: true
      },
      messages: {
        type: Array,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    emits: ['changeValue'],
    data() {
      return {
        dialog: false
      };
    },
    computed: {
      filteredMessages() {
        return this.messages.filter((msg) => String(msg).trim() !== '');
      }
    },
    watch: {
      showDialog(newValue) {
        this.dialog = newValue;
      }
    }
  };
</script>

<style>
  #dialog-acompanhamento-logs--table {
    width: 100% !important;
  }

  #dialog-acompanhamento-logs--table th,
  #dialog-acompanhamento-logs--table td {
    border-bottom: 1px solid rgb(211, 210, 210) !important;
    padding: 4px !important;
    text-align: justify !important;
    font-size: 14px !important;
    white-space: pre-wrap;
    word-break: break-word;
  }
</style>
